import React from 'react';

import ActionButton from 'components/action-button';
import { CardModal } from 'components/card-modal';
import { IClaimPointsScreenContentFragment, Maybe } from 'generated/sanity-graphql';
import { spacing } from 'styles/constants';

import {
  ClaimsPointContent,
  MainImage,
  StyledLink,
  Text,
  Title,
} from './loyalty-claim-points.styled';

export type LoyaltyClaimPointsViewButtonConfig = {
  hidden?: boolean;
  asLink?: boolean;
  replace?: boolean;
};

interface ILoyaltyClaimPointsViewProps {
  content?: IClaimPointsScreenContentFragment | null;
  children?: React.ReactNode;
  title?: React.ReactNode;
  body?: React.ReactNode;
  onPress: (str?: string | null) => void;
  topButtonConfig?: LoyaltyClaimPointsViewButtonConfig;
  bottomButtonConfig?: LoyaltyClaimPointsViewButtonConfig;
}

type IButton = {
  label?: Maybe<string>;
  url?: Maybe<string>;
} & LoyaltyClaimPointsViewButtonConfig;

const LoyaltyClaimPointsView = ({
  content,
  children,
  title,
  body,
  onPress,
  topButtonConfig,
  bottomButtonConfig,
}: ILoyaltyClaimPointsViewProps) => {
  const topButton: IButton = {
    label: content?.topButtonTitle?.locale,
    url: content?.topButtonUrl?.locale,
    ...topButtonConfig,
  };
  const bottomButton: IButton = {
    label: content?.bottomButtonTitle?.locale,
    url: content?.bottomButtonUrl?.locale,
    ...bottomButtonConfig,
  };

  return (
    <CardModal
      standardPadding
      alwaysShowHeader
      scrollView
      footer={
        <>
          {[topButton, bottomButton].map(
            ({ label, url, asLink, hidden, replace }, idx) =>
              !hidden &&
              label &&
              url &&
              (asLink ? (
                <StyledLink
                  key={label}
                  to={url}
                  replace={replace}
                  style={idx === 0 && { marginBottom: spacing.$4 }}
                >
                  {label}
                </StyledLink>
              ) : (
                <ActionButton
                  fullWidth
                  key={label}
                  onPress={() => onPress(url)}
                  marginBottom={idx === 0 ? spacing.$0_5 : 0}
                >
                  {label}
                </ActionButton>
              ))
          )}
        </>
      }
    >
      {content?.rewardsIcon && (
        <MainImage
          alt={content.screenTitle?.locale || ''}
          image={content.rewardsIcon.locale}
          height="50px"
        />
      )}
      {content?.secondImage && (
        <MainImage
          alt={content.screenTitle?.locale || ''}
          image={content.secondImage?.locale}
          height="130px"
        />
      )}
      <Title>{title ?? content?.screenTitle?.locale}</Title>
      {body ?? (
        <Text content={content?.instructionsTextBlock?.localeRaw} textAlign={{ md: 'center' }} />
      )}

      <ClaimsPointContent>{children}</ClaimsPointContent>
    </CardModal>
  );
};

export default LoyaltyClaimPointsView;
